import { FormFieldErrors, IErrorModalProps } from './error.types.ts';

export interface IErrorHandling {
  errorCode: number;
  redirectPath?: string;
  relatedFieldName?: keyof FormFieldErrors;
  callBack?: () => void;
  openModal?: boolean;
  modalProps?: IErrorModalProps;
}

export interface IError {
  code: number;
  codeName: string;
  localizedMessage: string;
  message: string;
  data?: {
    url?: string;
  };
}

export interface ServerErrorResponse {
  response: {
    data: {
      errors: IError[];
      httpStatus: number;
      reasonPhrase: string;
    };
    status?: number;
  };
}

export enum OnboardingFormFields {
  EMAIL = 'EMAIL',
  PASSWORD = 'PASSWORD',
  FIRST_NAME = 'FIRST_NAME',
  LAST_NAME = 'LAST_NAME',
  PHONE_NUMBER = 'PHONE_NUMBER',
  SSN = 'SSN',
  DATE_OF_BIRTH = 'DATE_OF_BIRTH',
  NATIONALITY = 'NATIONALITY',
  PASSPORT_NUMBER = 'PASSPORT_NUMBER',
  EXPIRATION_DATE = 'EXPIRATION_DATE',
  NATIONAL_ID_NUMBER = 'NATIONAL_ID_NUMBER',
  LINE1 = 'LINE1',
  APARTMENT = 'APARTMENT',
  CITY = 'CITY',
  COUNTRY = 'COUNTRY',
  STATE = 'STATE',
  ZIP = 'ZIP',
  HOME_LINE_1 = 'HOME_LINE_1',
  HOME_APARTMENT = 'HOME_APARTMENT',
  HOME_CITY = 'HOME_CITY',
  HOME_COUNTRY = 'HOME_COUNTRY',
  HOME_STATE = 'HOME_STATE',
  HOME_ZIP = 'HOME_ZIP',
  INDUSTRY = 'INDUSTRY',
  SUB_INDUSTRY = 'SUB_INDUSTRY',
  BUSINESS_NAME = 'BUSINESS_NAME',
  BUSINESS_EIN = 'BUSINESS_EIN',
  BUSINESS_REGISTER_STATE = 'BUSINESS_REGISTER_STATE',
  CHECKBOX_SOLE_BENEFICIAL_AGREEMENT = 'CHECKBOX_SOLE_BENEFICIAL_AGREEMENT',
  BUSINESS_LINE_1 = 'BUSINESS_LINE_1',
  BUSINESS_APARTMENT = 'BUSINESS_APARTMENT',
  BUSINESS_CITY = 'BUSINESS_CITY',
  BUSINESS_COUNTRY = 'BUSINESS_COUNTRY',
  BUSINESS_STATE = 'BUSINESS_STATE',
  BUSINESS_ZIP = 'BUSINESS_ZIP',
  BUSINESS_ADDRESS_SAME_AS_PRIMARY = 'BUSINESS_ADDRESS_SAME_AS_PRIMARY',
  GENERIC_ERROR_FIELD = 'GENERIC_ERROR_FIELD',
  OWNER_PERCENTAGE = 'OWNER_PERCENTAGE',
  OWNER_ACCESS_GRANTED = 'OWNER_ACCESS_GRANTED',
  OWNER_SAME_AS_PRIMARY = 'OWNER_SAME_AS_PRIMARY',
  CHECKBOX_FINAL_AGREEMENT = 'CHECKBOX_FINAL_AGREEMENT',
  OWNER_CENTER_MULTI_OWNER_CONSENT = 'OWNER_CENTER_MULTI_OWNER_CONSENT',
  OWNER_CENTER_CONSENT_ONLY_UBO = 'OWNER_CENTER_CONSENT_ONLY_UBO',
  OWNER_CENTER_OWNER_LIST = 'OWNER_CENTER_OWNER_LIST',
  ACCOUNT_OPENING_REASON = 'ACCOUNT_OPENING_REASON',
  PHONE_OTP = 'PHONE_OTP',
}

export const InputRegexMap = {
  firstName: /^[A-Za-z]+(?:\s[A-Za-z]+)*$/,
  lastName: /^[A-Za-z]+(?:\s[A-Za-z]+)*$/,
  phoneUS: /^\+1 \(\d{3}\) \d{3}-\d{4}$/,
  cityUS: /^[A-Za-z]+(?:\s[A-Za-z]+)*$/,
  lineOneUS: /^[A-Za-z0-9\s.]+$/,
  zipCode: /^\d+$/,
};

export enum QueryParamsToStore {
  TOKEN = 'token',
  CUSTOMER = 'customer',
  REFERRAL = 'r',
  SOURCE = 'source',
  CUSTOMER_ID = 'id',
  CUSTOMER_ID_V2 = 'customerId',
  AUTH_ID = 'authId',
}

export interface IPartnerDataResponse {
  partnerId: string;
  email: string;
  partnerName: string;
  firstName: string;
  lastName: string;
  institutionId: string;
  nonUsSupported: boolean;
}

export enum InstitutionIds {
  SUNRISE = 'b0c290e9-67e5-4973-b3e5-8b2720088ee8',
}

export enum OnboardingType {
  DIRECT = 'direct',
  CONNECT = 'connect',
}
